import { render, staticRenderFns } from "./LoadTransferSurfaceTable.vue?vue&type=template&id=c3df2634"
import script from "./LoadTransferSurfaceTable.vue?vue&type=script&lang=ts"
export * from "./LoadTransferSurfaceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3df2634')) {
      api.createRecord('c3df2634', component.options)
    } else {
      api.reload('c3df2634', component.options)
    }
    module.hot.accept("./LoadTransferSurfaceTable.vue?vue&type=template&id=c3df2634", function () {
      api.rerender('c3df2634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/LoadTransferSurfaceTable.vue"
export default component.exports